import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import ModalRoutes from '../../ModalRoutes';
import ReactTooltip from 'react-tooltip';
import axios from "axios";
import { debounce } from "lodash";
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';

import Navbar from '../../../Navbar';

import { LoadingIcon, LoadingIconRow } from '../../../Common/Loading_Icon';
import { checkCredentials } from '../../../../Helpers/checkCredentials.js';

import { setProfileDb } from '../../../../Actions/dataActions.js';
import { setList, setFilters } from '../../../../Actions/stakeholderActions.js';
import UserOverviewRow from '../Rows/Row_UserOverview';
import { constants } from '../../../../Helpers/Constants';
import { DivisionIcon, VCIcon } from '../../../Common/Buttons/TypeIcons';
import { UserPress, UserEmployee, UserDealer, UserFleet, UserRequested, UserInvited, UserRejected, UserDeactivate, ActivityInactive, ActivityActive, UserApproved, TagDefault, UserAddWhite, TagAddWhite } from '../../../Common/Buttons/Icons';
import { Trans } from 'react-i18next';

class UserOverview extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading_customers: true,
            sort_filter: null, sort_direction: null,
            current_filters: {
                'search': "", 
                'role': {}, 
                'status': {'pending': false, 'active': false, 'tag': false, 'invited': false, 'rejected': false, 'inactive': false}, 
                'activity': {'active': false, 'inactive': false},
                'sh': {},
                'vmh': {},
                'tier': {1: false, 2: false, 3: false, 4: false, 5: false},
                'bookings': {'min': 0, 'max': 100},
                'last_booking': {'min': 0, 'max': 90},
                'member': {'min': 0, 'max': 90}
            },
            previous_filters: {
                'search': "", 
                'role': {}, 
                'status': {'pending': false, 'active': false, 'tag': false, 'invited': false, 'rejected': false, 'inactive': false}, 
                'activity': {'active': false, 'inactive': false},
                'sh': {},
                'vmh': {},
                'tier': {1: false, 2: false, 3: false, 4: false, 5: false},
                'bookings': {'min': 0, 'max': 100},
                'last_booking': {'min': 0, 'max': 90},
                'member': {'min': 0, 'max': 90}
            },
            default_filters: {
                'search': "", 
                'role': {}, 
                'status': {'pending': false, 'active': false, 'tag': false, 'invited': false, 'rejected': false, 'inactive': false}, 
                'activity': {'active': false, 'inactive': false},
                'sh': {},
                'vmh': {},
                'tier': {1: false, 2: false, 3: false, 4: false, 5: false},
                'bookings': {'min': 0, 'max': 100},
                'last_booking': {'min': 0, 'max': 90},
                'member': {'min': 0, 'max': 90}
            },
            filter_dropdowns: {'role': false, 'status': false, 'activity': false, 'sh': false, 'vmh': false, 'tier': false, 'bookings': false, 'last_booking': false, 'member': false},
            total_users: 0,
            requests: 0,
            next_page: 1,
            current_num_users: 0,
            grabbing_next: false,
            customers_data: {'filters': {'sh': [], 'vmh': [], 'user_role': []}, 'data': {'total': 0}},
            max_customers_render: 8,
            initial_max_customers_render: 8,
            has_oem_access: false,
            searching: false,
            set_max_customers: false,
            mobile_filters: false,
            mobile_quick: false
        };
        this.watchScroll = this.watchScroll.bind(this);
        this.checkScreenHeight = this.checkScreenHeight.bind(this);
        
        this.inviteOverlay = this.inviteOverlay.bind(this);
        this.internalTagOverlay = this.internalTagOverlay.bind(this);
        this.applyFilters = this.applyFilters.bind(this);
        this.resetFilters = this.resetFilters.bind(this);
        
        this.toggleMobile = this.toggleMobile.bind(this);
        
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.handleChange = debounce(this.handleChange, 500);
        this.clearSearch = this.clearSearch.bind(this);

        this.updateButton = debounce(this.updateButton, 100);
        this.updateCheckBox = this.updateCheckBox.bind(this);
        this.updateSorting = this.updateSorting.bind(this);

        this.addSortClasses = this.addSortClasses.bind(this);
        this.changedFilters = this.changedFilters.bind(this);
        this.categoryCollapsable = this.categoryCollapsable.bind(this);
    }

    componentDidMount() {
        document.title = "User Overview - FleetXPress"
        var self = this;
        
        axios.get('/ajax/customers_list/index')
        .then(function(response) {
            checkCredentials(response);
            self.props.dispatch(setProfileDb(response?.data.data.data, self.props.data.profile_db));
            self.props.dispatch(setList("SET_USER_LIST", response?.data.data.data))
            
            var filters = self.state.current_filters;
            for (var i = 0; i < response?.data.filters.user_role.length; i++) {
                filters['role'][response?.data.filters.user_role[i]] = false;
            }

            for (var i = 0; i < response?.data.filters.sh.length; i++) {
                filters['sh'][response?.data.filters.sh[i].SH_ID] = false;
            }

            for (var i = 0; i < response?.data.filters.vmh.length; i++) {
                filters['vmh'][response?.data.filters.vmh[i].VMH_ID] = false;
            }

            self.props.dispatch(setFilters(JSON.parse(JSON.stringify(filters)), null, null))

            var next_page = null
            if (response?.data.data.current_page < response?.data.data.last_page) {
                next_page = response?.data.data.current_page + 1
            }
            
            self.setState({
                loading_customers: false,
                customers_data: response?.data,
                total_users: response?.data.info.total_users,
                requests: response?.data.info.requests,
                current_num_users: response?.data.data.total,
                next_page: next_page,
                grabbing_next: false,
                current_filters: JSON.parse(JSON.stringify(filters)),
                previous_filters: JSON.parse(JSON.stringify(filters)),
                default_filters: JSON.parse(JSON.stringify(filters)),
            })
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    componentDidUpdate() {
        this.checkScreenHeight()
    }

    checkScreenHeight() {
        if (! this.state.set_max_customers) {
            var num_to_add = Math.round((document.documentElement.clientHeight - (this.state.max_customers_render * 52)) / 52)

            this.setState({
                max_customers_render: this.state.max_customers_render + num_to_add,
                initial_max_customers_render: this.state.max_customers_render + num_to_add,
                set_max_customers: true
            })
        }

        if (this.state.set_max_customers && this.state.max_customers_render > this.props.stakeholder.user_list.length && this.state.next_page && ! this.state.loading_customers && ! this.state.grabbing_next) {
            this.setState({
                grabbing_next: true
            })
            this.applyFilters(this.state.sort_filter, this.state.sort_direction, this.state.next_page)
        }
    }

    watchScroll(e) {
        if (! this.state.loading_customers && this.state.next_page !== null && !this.state.grabbing_next) {
            var scroll_percentage = (e.target.scrollTop / (e.target.scrollHeight - e.target.clientHeight)) * 100
            if (scroll_percentage > 60) {
                this.setState({
                    grabbing_next: true
                })
                this.applyFilters(this.state.sort_filter, this.state.sort_direction, this.state.next_page)
            }
        }
    }


    toggleMobile(name) {
        this.setState({
            [name]: !this.state[name]
        })
    }

    handleChange(e) {
        var search = document.getElementById('searchbar').value;
        var filters = this.state.current_filters;
        filters['search'] = search;

        this.setState({
            searching: true,
            current_filters: filters
        })

        this.applyFilters()
    }

    clearSearch() {
        var filters = this.state.current_filters;
        filters['search'] = "";
        document.getElementById('searchbar').value = "";


        this.setState({
            current_filters: filters
        })

        this.applyFilters()
    }

    applyFilters(sort_filter = this.state.sort_filter, sort_direction = this.state.sort_direction, page = 1) {
        var self = this;

        if(page === 1) {
            this.setState({
                loading_customers: true,
                mobile_filters: false
            })
        }

        var data = {
                    search_term: this.state.current_filters.search,
                    sort_filter: sort_filter,
                    sort_direction: sort_direction,
                    bookings_min: this.state.current_filters.bookings.min,
                    bookings_max: this.state.current_filters.bookings.max,
                    last_booking_min: this.state.current_filters.last_booking.min,
                    last_booking_max: this.state.current_filters.last_booking.max,
                    member_min: this.state.current_filters.member.min,
                    member_max: this.state.current_filters.member.max
                }


        var filters = this.state.current_filters;
        var categories = Object.keys(filters);
        for (var i = 0; i < categories.length; i++) {
            data[categories[i]] = "";
            if (typeof filters[categories[i]] === "object" && (categories[i] !== "bookings" || categories[i] !== "last_booking" || categories[i] !== "member")) {
                var items = Object.keys(filters[categories[i]]);
                for (var k = 0; k < items.length; k++) {
                    if (filters[categories[i]][items[k]] === true) {
                        if (data[categories[i]] === "") {
                            data[categories[i]] = items[k]
                        } else {
                            data[categories[i]] = data[categories[i]] + "#" + items[k]
                        }
                    }
                }
            }
        }

        this.props.dispatch(setFilters(JSON.parse(JSON.stringify(self.state.current_filters)), sort_direction, sort_filter))
        
        axios({
            method: 'post',
            url: '/ajax/user_list/update?page=' + page,
            data: data
        })
        .then(function(response) {
            checkCredentials(response)
            self.props.dispatch(setProfileDb(response?.data.data.data, self.props.data.profile_db));
            
            if (page > 1) {
                self.props.dispatch(setList("SET_USER_LIST", self.props.stakeholder.user_list.concat(response?.data.data.data)));
            } else {
                self.props.dispatch(setList("SET_USER_LIST", response?.data.data.data))
            }

            var next_page = null
            if (response?.data.data.next_page_url) {
                next_page = response?.data.data.current_page + 1
            }

            self.setState({
                loading_customers: false,
                customers_data: response?.data,
                max_customers_render: self.state.initial_max_customers_render,
                current_num_users: response?.data.data.total,
                next_page: next_page,
                searching: false,
                grabbing_next: false,
                previous_filters: JSON.parse(JSON.stringify(self.state.current_filters))
            })
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    inviteOverlay(e) {
        e.stopPropagation();
        var base_url = (this.props.match.url).split('/')[1]
        this.props.history.push("/" + base_url + '/invitation/new')
    }

    internalTagOverlay(e) {
        e.stopPropagation();
        var base_url = (this.props.match.url).split('/')[1]
        this.props.history.push("/" + base_url + '/internaltag/new')
    }

    updateSorting(name) {
        var sort_direction = this.state.sort_direction;
        var sort_filter = this.state.sort_filter;

        if (sort_filter !== name) {
            sort_filter = name;
            sort_direction = "desc";
        } else {
            if (sort_direction === "desc") {
                sort_direction = "asc"
            } else if (sort_direction === "asc") {
                sort_direction = null
                sort_filter = null
            } else {
                sort_filter = name;
                sort_direction = "asc"
            }
        }

        this.props.dispatch(setFilters(JSON.parse(JSON.stringify(this.state.previous_filters)), sort_direction, sort_filter))

        this.setState({
            sort_direction: sort_direction,
            sort_filter: sort_filter
        })

        this.applyFilters(sort_filter, sort_direction)
    }

    toggleDropdown(type) {
        var filter_dropdowns = this.state.filter_dropdowns
        filter_dropdowns[type] = !filter_dropdowns[type]
        this.setState({
            filter_dropdowns: filter_dropdowns
        })
    }

    updateButton(button) {
        var filters = this.state.default_filters

        // loop through all other activity quick filters and set them to false (only one filter can be active at a time)
        for (var key in filters['activity']) {
            if(key != button) {
                filters['activity'][key] = false;
            }
        }

        // check if pending quick filter is selected, if not reset it
        if(button != "pending")
        {
            filters['status']['pending'] = false;
        }

        if (button === "pending") {
            filters['status']['pending'] = !this.state.current_filters['status']['pending']
            if (!this.state.filter_dropdowns.status && filters['status']['pending'])
            {
                var filter_dropdowns = this.state.filter_dropdowns
                filter_dropdowns['status'] = true
                this.setState({
                    filter_dropdowns: filter_dropdowns
                })
            }
        } else if (button === "active" || button === "inactive") {
            filters['activity'][button] = !this.state.current_filters['activity'][button]
            if (!this.state.filter_dropdowns.activity && filters['activity'][button])
            {
                var filter_dropdowns = this.state.filter_dropdowns
                filter_dropdowns['activity'] = true
                this.setState({
                    filter_dropdowns: filter_dropdowns
                })
            }
        }

        this.setState({
            current_filters: JSON.parse(JSON.stringify(filters)),
            previous_filters: JSON.parse(JSON.stringify(filters))
        })

        this.applyFilters();
    }

    updateCheckBox(category, check) {
        var filters = this.state.current_filters;
        filters[category][check] = !this.state.current_filters[category][check]
        this.setState({
            current_filters: filters
        })
    }

    updateRange(e, category) {
        var filters = this.state.current_filters;
        filters[category]['min'] = e[0]
        filters[category]['max'] = e[1]

        this.setState({
            current_filters: filters
        })
    }

    /*
    * Compares previous filters with recently checked ones, returns true if the filters have been changed and can be updated
    */
    changedFilters(compare_dictionary) {
        if (JSON.stringify(compare_dictionary) !== JSON.stringify(this.state.current_filters)) {
            return true;
        }

        return false;
    }

    addSortClasses(name) {
        if (this.state.sort_filter === name) {
            if (this.state.sort_direction === "asc") {
                return " fa-sort-up primary"
            } else if (this.state.sort_direction === "desc"){
                return " fa-sort-down primary"
            }
        } else {
            return " fa-sort"
        }
    }

    resetFilters() {
        this.setState({
            current_filters: JSON.parse(JSON.stringify(this.state.default_filters)),
            previous_filters: JSON.parse(JSON.stringify(this.state.default_filters)),
            loading_customers: true,
            mobile_filters: false
        })
        
        var self = this;
        this.props.dispatch(setFilters(JSON.parse(JSON.stringify(self.state.default_filters)), this.state.sort_direction, this.state.sort_filter))

        axios.get('/ajax/customers_list/index')
        .then(function(response) {
            checkCredentials(response);
            self.props.dispatch(setProfileDb(response?.data.data.data, self.props.data.profile_db));
            self.props.dispatch(setList("SET_USER_LIST", response?.data.data.data))

            var next_page = null
            if (response?.data.data.current_page < response?.data.data.last_page) {
                next_page = response?.data.data.current_page + 1
            }

            self.setState({
                loading_customers: false,
                current_num_users: response?.data.data.total,
                next_page: next_page
            })
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    /*
    * Checks if a category is collapsable 
    */
    categoryCollapsable(category) {
        var filters = this.state.current_filters;
        var items = Object.keys(filters[category]);
        for (var k = 0; k < items.length; k++) {
            if (filters[category][items[k]]) {
                return false;
            }
        }
        return true;
    }

    render() {
        return (
            <div>
                <div className = "bkg-white-dark listviewnew">
                    <Navbar history={this.props.history} match={this.props.match} location={this.props.location} />
                    <div className = "titlebar">
                        <div className = "titlebar-left">
                            <div className = "left">
                                <h1><Trans>User Overview</Trans></h1>
                            </div>
                        </div>
                        <div className = "titlebar-right">
                            <div className = "right">
                                <div className = "desktop-action">
                                    <a className = "button primary px-32" onClick={this.inviteOverlay}><span className = "mr-8" style={{verticalAlign: "sub"}}>{UserAddWhite()}</span><span><Trans>Invite User</Trans></span></a>
                                    <a className = "button primary ml-8 px-32" onClick={this.internalTagOverlay}><span className = "mr-8" style={{verticalAlign: "sub"}}>{TagAddWhite()}</span><Trans>Add Internal Tag</Trans></a>
                                </div>
                                <div className = "mobile-action">
                                    <a className = "button primary circle px-32" onClick={this.inviteOverlay} style = {{lineHeight:'28px'}}><img src = "images/png-icons/inviteuser-white.png" style={{width:'18px'}}/></a>
                                    <a className = "button primary circle ml-8 px-32" onClick={this.internalTagOverlay} style = {{lineHeight:'28px'}}><img src = "images/png-icons/addinternaltag-white.png" style={{width:'18px'}}/></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className = "list-container">
                        <div className = "list-wrapper">
                            <div className = {"filterbar" + (this.state.mobile_filters ? " is-shown" : "")}> {/*add class 'is-shown' to unhide on mobile */}
                                <div className = "filtertitle-wrapper">
                                    <div className = "filtertitle">
                                        {this.state.total_users > 0 ? <h2>{this.state.current_num_users}/{this.state.total_users} Users</h2> : <h2>0 Users</h2>}
                                        <a className = "close-icon" onClick={() => (this.toggleMobile('mobile_filters'))}>
                                            <img src = "images/png-icons/close-grey.png"/>
                                        </a>
                                    </div>
                                </div>
                                <div className = "filtersection">
                                    <div className = "filtersection-wrapper">
                                        <ul>
                                            <li className={"filter-expandable" + (this.state.filter_dropdowns.role ? " is-expanded" : "")} >
                                                <span className = "filter-name"><Trans>User Role</Trans></span>
                                                {
                                                    this.categoryCollapsable('role') ?
                                                        <div className={"expand-btn" + (this.state.filter_dropdowns.role ? " is-expanded": "")} onClick={() => this.toggleDropdown('role')}></div>
                                                    :
                                                        <div className="expand-btn is-expanded disabled"></div>
                                                }
                                                <div className = "clearfix"></div>
                                                <ul className = "filter-ul">
                                                    {
                                                        this.state.customers_data.filters.user_role.map((user_role, i) => {
                                                            var name;
                                                            var icon; 
                                                
                                                            //Customer profile isnt a role that should be displayed
                                                            if (user_role !== constants.user_role.customer_profile) {
                                                                if (user_role === constants.user_role.dealer) {
                                                                    name = "Dealer"
                                                                    icon = UserDealer()
                                                                } else if (user_role === constants.user_role.fleet_buyer) {
                                                                    name = "Fleet buyer"
                                                                    icon = UserFleet()
                                                                } else if (user_role === constants.user_role.media_influencer) {
                                                                    name = "Press"
                                                                    icon = UserPress()
                                                                } else if (user_role === constants.user_role.employee) {
                                                                    name = "Employee"
                                                                    icon = UserEmployee()
                                                                } else if (user_role === constants.user_role.integrated_client) {
                                                                    name = "Integrated Client"
                                                                    icon = UserEmployee()
                                                                }
                                                    
                                                                return(
                                                                    <li key={'user_role_filter_' + i}>
                                                                        <label className = "has-icon">
                                                                            <input type = "checkbox" checked={this.state.current_filters['role'][user_role]} onClick={() => this.updateCheckBox('role', user_role)}/>
                                                                            <span className = "checkmark"></span>
                                                                                <span className="mr-4">{icon}</span>
                                                                                {name}
                                                                        </label>
                                                                    </li>
                                                                )
                                                            }
                                                        })
                                                    }
                                                </ul>
                                            </li> 
                                            <li className={"filter-expandable" + (this.state.filter_dropdowns.status ? " is-expanded" : "")}>
                                                <span className = "filter-name"><Trans>Status</Trans></span>
                                                {
                                                    this.categoryCollapsable('status') ?
                                                        <div className={"expand-btn" + (this.state.filter_dropdowns.status ? " is-expanded": "")} onClick={() => this.toggleDropdown('status')}></div>
                                                    :
                                                        <div className="expand-btn is-expanded disabled"></div>
                                                }
                                                <div className = "clearfix"></div>
                                                <ul className = "filter-ul filter-user-status filter-font-small">
                                                    <li>
                                                        <label className = "has-icon">
                                                            <input type = "checkbox" checked={this.state.current_filters.status.pending} onClick={() => this.updateCheckBox('status', 'pending')}/>
                                                            <span className = "checkmark"></span>
                                                                <span className="mr-4">{UserRequested()}</span>
                                                            <span className = "yellow"><Trans>Request</Trans></span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label className = "has-icon">
                                                            <input type = "checkbox" checked={this.state.current_filters.status.active} onClick={() => this.updateCheckBox('status', 'active')}/>
                                                            <span className = "checkmark"></span>
                                                                <span className="mr-4">{UserApproved()}</span>
                                                            <span className = "green"><Trans>Approved</Trans></span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label className = "has-icon">
                                                            <input type = "checkbox" checked={this.state.current_filters.status.tag} onClick={() => this.updateCheckBox('status', 'tag')}/>
                                                            <span className = "checkmark"></span>
                                                                <span className="mr-4">{TagDefault()}</span>
                                                            <span className = "blue"><Trans>Internal Tag</Trans></span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label className = "has-icon">
                                                            <input type = "checkbox" checked={this.state.current_filters.status.invited} onClick={() => this.updateCheckBox('status', 'invited')}/>
                                                            <span className = "checkmark"></span>
                                                                <span className="mr-4">{UserInvited()}</span>
                                                            <span className = "blue"><Trans>Invited</Trans></span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label className = "has-icon">
                                                            <input type = "checkbox" checked={this.state.current_filters.status.rejected} onClick={() => this.updateCheckBox('status', 'rejected')}/>
                                                            <span className = "checkmark"></span>
                                                                <span className="mr-4">{UserRejected()}</span>
                                                            <span className = "red"><Trans>Rejected</Trans></span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label className = "has-icon">
                                                            <input type = "checkbox" checked={this.state.current_filters.status.inactive} onClick={() => this.updateCheckBox('status', 'inactive')}/>
                                                            <span className = "checkmark"></span>
                                                                <span className="mr-4">{UserDeactivate()}</span>
                                                            <span className = "grey"><Trans>Deactivated</Trans></span>
                                                        </label>
                                                    </li>
                                                    
                                                </ul>
                                            </li> 
                                            <li className={"filter-expandable" + (this.state.filter_dropdowns.activity ? " is-expanded" : "")}>
                                                <span className = "filter-name"><Trans>Booking Activity</Trans>
                                                </span>
                                                {
                                                    this.categoryCollapsable('activity') ?
                                                        <div className={"expand-btn" + (this.state.filter_dropdowns.activity ? " is-expanded": "")} onClick={() => this.toggleDropdown('activity')}></div>
                                                    :
                                                        <div className="expand-btn is-expanded disabled"></div>
                                                }
                                                <div className = "clearfix"></div>
                                                <ul className = "filter-ul filter-font-small">
                                                    <li>
                                                        <label className = "has-icon">
                                                            <input type = "checkbox" checked={this.state.current_filters.activity.active} onClick={() => this.updateCheckBox('activity', 'active')}/>
                                                            <span className = "checkmark"></span>
                                                                <span className="mr-4">{ActivityActive()}</span>
                                                            <span className = "green"><Trans>Active</Trans></span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label className = "has-icon">
                                                            <input type = "checkbox" checked={this.state.current_filters.activity.inactive} onClick={() => this.updateCheckBox('activity', 'inactive')}/>
                                                            <span className = "checkmark"></span>
                                                                <span className="mr-4">{ActivityInactive()}</span>
                                                            <span className = "red"><Trans>Inactive</Trans></span>
                                                        </label>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li className={"filter-expandable" + (this.state.filter_dropdowns.sh ? " is-expanded" : "")}>
                                                <span className = "filter-name"><Trans>Pool</Trans></span>
                                                {
                                                    this.categoryCollapsable('sh') ?
                                                        <div className={"expand-btn" + (this.state.filter_dropdowns.sh ? " is-expanded": "")} onClick={() => this.toggleDropdown('sh')}></div>
                                                    :
                                                        <div className="expand-btn is-expanded disabled"></div>
                                                }
                                                <div className = "clearfix"></div>
                                                <ul className = "filter-ul">
                                                    {
                                                        this.state.customers_data.filters.sh.map((division) => {
                                                            return(
                                                                <li>
                                                                    <label className = "has-icon">
                                                                        <input type = "checkbox" checked={this.state.current_filters.sh[division.SH_ID]} onClick={() => {this.updateCheckBox('sh', division.SH_ID)}}/>
                                                                        <span className = "checkmark"></span>
                                                                        {DivisionIcon(division, undefined, undefined, undefined, true)}
                                                                        {division.Display_Name} - {division.Division}
                                                                    </label>
                                                                </li>
                                                            )
                                                        })
                                                    }
                                                </ul>
                                            </li> 
                                            <li className={"filter-expandable" + (this.state.filter_dropdowns.vmh ? " is-expanded" : "")}>
                                                <span className = "filter-name"><Trans>Facility</Trans></span>
                                                {
                                                    this.categoryCollapsable('vmh') ?
                                                        <div className={"expand-btn" + (this.state.filter_dropdowns.vmh ? " is-expanded": "")} onClick={() => this.toggleDropdown('vmh')}></div>
                                                    :
                                                        <div className="expand-btn is-expanded disabled"></div>
                                                }
                                                <div className = "clearfix"></div>
                                                <ul className = "filter-ul">
                                                    {
                                                        this.state.customers_data.filters.vmh.map((vmh) => {
                                                            return(
                                                                <li>
                                                                    <label className = "has-icon">
                                                                        <input type = "checkbox" checked={this.state.current_filters.vmh[vmh.VMH_ID]} onClick={() => {this.updateCheckBox('vmh', vmh.VMH_ID)}}/>
                                                                        <span className = "checkmark"></span>
                                                                        {VCIcon(vmh, undefined, undefined, undefined, true)}
                                                                        {vmh.Display_Name} - {vmh.Display_City}
                                                                    </label>
                                                                </li>
                                                            )
                                                        })
                                                    }
                                                </ul>
                                            </li>
                                            <li className={"filter-expandable" + (this.state.filter_dropdowns.tier ? " is-expanded" : "")}>
                                                <span className = "filter-name"><Trans>Tier</Trans></span>
                                                {
                                                    this.categoryCollapsable('tier') ?
                                                        <div className={"expand-btn" + (this.state.filter_dropdowns.tier ? " is-expanded": "")} onClick={() => this.toggleDropdown('tier')}></div>
                                                    :
                                                        <div className="expand-btn is-expanded disabled"></div>
                                                }
                                                <div className = "clearfix"></div>
                                                <ul className = "filter-ul">
                                                    <li>
                                                        <label className = "has-icon">
                                                            <input type = "checkbox" checked={this.state.current_filters.tier[5]} onClick={() => this.updateCheckBox('tier', 5)}/>
                                                            <span className = "checkmark"></span>
                                                            <div className = "rating-stars">
                                                                <ul id = "stars">
                                                                    <li className = "star tier selected">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                    <li className = "star tier selected">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                    <li className = "star tier selected">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                    <li className = "star tier selected">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                    <li className = "star tier selected">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label className = "has-icon">
                                                            <input type = "checkbox" checked={this.state.current_filters.tier[4]} onClick={() => this.updateCheckBox('tier', 4)}/>
                                                            <span className = "checkmark"></span>
                                                            <div className = "rating-stars">
                                                                <ul id = "stars">
                                                                    <li className = "star tier selected">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                    <li className = "star tier selected">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                    <li className = "star tier selected">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                    <li className = "star tier selected">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                    <li className = "star tier">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label className = "has-icon">
                                                            <input type = "checkbox" checked={this.state.current_filters.tier[3]} onClick={() => this.updateCheckBox('tier', 3)}/>
                                                            <span className = "checkmark"></span>
                                                            <div className = "rating-stars">
                                                                <ul id = "stars">
                                                                    <li className = "star tier selected">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                    <li className = "star tier selected">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                    <li className = "star tier selected">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                    <li className = "star tier">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                    <li className = "star tier">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label className = "has-icon">
                                                            <input type = "checkbox" checked={this.state.current_filters.tier[2]} onClick={() => this.updateCheckBox('tier', 2)}/>
                                                            <span className = "checkmark"></span>
                                                            <div className = "rating-stars">
                                                                <ul id = "stars">
                                                                    <li className = "star tier selected">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                    <li className = "star tier selected">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                    <li className = "star tier">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                    <li className = "star tier">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                    <li className = "star tier">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label className = "has-icon">
                                                            <input type = "checkbox" checked={this.state.current_filters.tier[1]} onClick={() => this.updateCheckBox('tier', 1)}/>
                                                            <span className = "checkmark"></span>
                                                            <div className = "rating-stars">
                                                                <ul id = "stars">
                                                                    <li className = "star tier selected">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                    <li className = "star tier">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                    <li className = "star tier">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                    <li className = "star tier">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                    <li className = "star tier">
                                                                        <i className = "fa fa-star fa-fw"></i>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </label>
                                                    </li>
                                                </ul>
                                            </li> 
                                            <li className={"filter-expandable" + (this.state.filter_dropdowns.bookings ? " is-expanded" : "")}>
                                                <span className = "filter-name"><Trans>Bookings</Trans></span>
                                                {
                                                    this.state.current_filters.bookings.min === 0 && this.state.current_filters.bookings.max === 100 ?
                                                        <div className={"expand-btn" + (this.state.filter_dropdowns.bookings ? " is-expanded": "")} onClick={() => this.toggleDropdown('bookings')}></div>
                                                    :
                                                        <div className="expand-btn is-expanded disabled"></div>
                                                }
                                                <div className = "clearfix"></div>
                                                <ul className = "filter-ul filter-slider">
                                                    <li>
                                                        <p>{this.state.current_filters.bookings.min} - {this.state.current_filters.bookings.max}{this.state.current_filters.bookings.max === 100 ? <span>+</span> : null} <Trans>bookings</Trans></p>
                                                        <Range allowCross={false} min={0} max={100} defaultValue={[0, 100]} value={[this.state.current_filters.bookings.min, this.state.current_filters.bookings.max]} onChange={(e) => {this.updateRange(e, "bookings")}} />
                                                        <div className = "clearfix"></div>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li className={"filter-expandable" + (this.state.filter_dropdowns.last_booking ? " is-expanded" : "")}>
                                                <span className = "filter-name"><Trans>Last Booking</Trans></span>
                                                {
                                                    this.state.current_filters.last_booking.min === 0 && this.state.current_filters.last_booking.max === 90 ?
                                                        <div className={"expand-btn" + (this.state.filter_dropdowns.last_booking ? " is-expanded": "")} onClick={() => this.toggleDropdown('last_booking')}></div>
                                                    :
                                                        <div className="expand-btn is-expanded disabled"></div>
                                                }
                                                <div className = "clearfix"></div>
                                                <ul className = "filter-ul filter-slider">
                                                    <li>
                                                        <p>{this.state.current_filters.last_booking.min} - {this.state.current_filters.last_booking.max}{this.state.current_filters.last_booking.max === 90 ? <span>+</span> : null} <Trans>days</Trans></p>
                                                        <Range allowCross={false} min={0} max={90}defaultValue={[0, 90]} value={[this.state.current_filters.last_booking.min, this.state.current_filters.last_booking.max]} onChange={(e) => {this.updateRange(e, "last_booking")}} />
                                                    </li>
                                                </ul>
                                            </li>
                                            <li className={"filter-expandable" + (this.state.filter_dropdowns.member ? " is-expanded" : "")}>
                                                <span className = "filter-name"><Trans>Member Since</Trans></span>
                                                {
                                                    this.state.current_filters.member.min === 0 && this.state.current_filters.member.max === 90 ?
                                                        <div className={"expand-btn" + (this.state.filter_dropdowns.member ? " is-expanded": "")} onClick={() => this.toggleDropdown('member')}></div>
                                                    :
                                                        <div className="expand-btn is-expanded disabled"></div>
                                                }
                                                <div className = "clearfix"></div>
                                                <ul className = "filter-ul filter-slider">
                                                    <li>
                                                        <p>{this.state.current_filters.member.min} - {this.state.current_filters.member.max}{this.state.current_filters.member.max === 90 ? <span>+</span> : null} <Trans>days</Trans></p>
                                                        <Range allowCross={false} min={0} max={90} defaultValue={[0, 90]} value={[this.state.current_filters.member.min, this.state.current_filters.member.max]} onChange={(e) => {this.updateRange(e, "member")}} />
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className = "action-bottom">
                                    <div className = "right">
                                        <a className = {"button secondary mr-8 px-32 no-margin" + (this.changedFilters(this.state.default_filters) ? "" : " disabled")} onClick={() => this.resetFilters()}><Trans>Reset</Trans></a>
                                        <a className = {"button primary px-32 no-margin" + (this.changedFilters(this.state.previous_filters) ? "" : " disabled")} onClick={() => this.applyFilters()}><Trans>Apply Filters</Trans></a>
                                    </div>
                                </div>
                            </div> {/*End Filter Bar*/}
                            <div className = "mainsection">
                                <div className = "searchbar-section">
                                    <div className = "left">
                                        <div className = "searchbar-wrapper">
                                            <a className = "float-left button border white px-32 icon-btn filterbar-btn-mobile" onClick={() => {this.toggleMobile('mobile_filters')}}><img src = "images/png-icons/filter-grey.png"/> </a> 
                                            <div className = "search-field-container">
                                                <input className="search-input-field no-margin" type="text" placeholder = "Search Users" id="searchbar" onChange={(e) => {this.handleChange(e)}}/>
                                                {/*Show when searching*/}
                                                {
                                                    this.state.searching ?
                                                        <div className="loading-wrapper">
                                                            <div className="lds-ring bkg-border-primary"><div></div><div></div><div></div><div></div></div>
                                                        </div>
                                                    :
                                                        null
                                                }

                                                {/*Show when input field has text*/}
                                                {
                                                    this.state.current_filters.search.length && !this.state.searching > 0 ?
                                                        <a className = "close-icon" onClick={this.clearSearch}>
                                                            <img src = "images/png-icons/close-grey.png"/>
                                                        </a> 
                                                    :
                                                        null
                                                }
                                            </div>
                                            <div className = "quick-filters float-left">
                                                <a className = {"button px-32" + (this.state.previous_filters.activity.active ? " primary" : " white border")} onClick={() => {this.updateButton('active')}}><Trans>Active Users</Trans><img src = "images/icon-close.png" className="close-icon"/></a>
                                                <a className = {"button px-32" + (this.state.previous_filters.activity.inactive ? " primary" : " white border")} onClick={() => {this.updateButton('inactive')}}><Trans>Inactive Users</Trans><img src = "images/icon-close.png" className="close-icon"/></a>
                                            <a className = {"button px-32" + (this.state.previous_filters.status.pending ? " primary" : " white border")} onClick={() => {this.updateButton('pending')}}><Trans>Requests</Trans> <img src = "images/icon-close.png" className="close-icon"/>{this.state.requests > 0 ? <div className = "number-badge alert mt-8">{this.state.requests}</div> : null}</a>
                                            </div>
                                            <div className = {"quick-filters-mobile" + (this.state.mobile_quick ? " is-shown" : "")}>
                                                <a className = "float-left button border white px-32 icon-btn quickfilter-btn-mobile" onClick={() => {this.toggleMobile("mobile_quick")}}><img src = "images/png-icons/ellipsis-grey.png"/> </a>
                                                <div className = "quick-filters-dropdown">
                                                    <div className = "quickfilter-title">
                                                        <h3 className = "subheading"><Trans>Quick Filters</Trans></h3>
                                                    </div>
                                                    <ul>
                                                        <li>
                                                            <label className = "has-icon" onClick={() => {this.updateButton('active')}}>
                                                                <input type = "checkbox" checked={this.state.previous_filters.activity.active}/>
                                                                <span className = "checkmark"></span>
                                                                <Trans>Active Users</Trans>
                                                            </label>
                                                        </li>
                                                        <li>
                                                            <label className = "has-icon" onClick={() => {this.updateButton('inactive')}}>
                                                                <input type = "checkbox" checked={this.state.previous_filters.activity.inactive}/>
                                                                <span className = "checkmark"></span>
                                                                <Trans>Inactive Users</Trans>
                                                            </label>
                                                        </li>
                                                        <li>
                                                            <label className = "has-icon" onClick={() => {this.updateButton('pending')}}>
                                                                <input type = "checkbox" checked={this.state.previous_filters.status.pending}/>
                                                                <span className = "checkmark"></span>
                                                                <Trans>Requests</Trans>
                                                            </label>
                                                        </li>
                                                    </ul>
                                                </div> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className = "table-section" onScroll={this.watchScroll}>
                                        {
                                            this.state.loading_customers ? 
                                                <LoadingIcon />
                                            :
                                                this.state.total_users > 0 ?
                                                    this.props.stakeholder.user_list.length > 0 ?
                                                        <div className = "table-wrapper" onScroll={this.watchScroll}>
                                                            <table>
                                                                <thead>
                                                                    <tr>
                                                                        <th className = {this.state.sort_filter === "name" ? "is-sorted" : "th"} onClick={() => {this.updateSorting("name")}}>User <i className = {"sort-icon fas black-lightest" + (this.addSortClasses("name"))}></i></th>
                                                                        <th className = {this.state.sort_filter === "status" ? "is-sorted th-center" : "th-center"} onClick={() => {this.updateSorting("status")}}>Status <i className = {"sort-icon fas black-lightest" + (this.addSortClasses("status"))}></i></th>
                                                                        <th className = {"double-line" + (this.state.sort_filter === "activity" ? " is-sorted th-center" : " th-center")} onClick={() => {this.updateSorting("activity")}}>
                                                                            <div className = "th-wrapper" style = {{width:'60px'}}>
                                                                                <div className = "th-text float-left"><Trans>Booking<br />Activity</Trans></div><i className = {"sort-icon fas black-lightest float-left" + (this.addSortClasses("activity"))}></i>
                                                                                <div className = "clearfix"></div>
                                                                            </div>
                                                                            <i className="fas fa-info-circle black-lighter"  data-tip="Active Users have booked in the last 90 days. Inactive Users haven't had any bookings in the last 90 days."></i>
                                                                            {/* <ReactTooltip effect="solid" /> */}
                                                                        </th>
                                                                        <th className = "not-sortable th-center"><Trans>Department</Trans></th>
                                                                        <th className = "not-sortable th-center"><Trans>Vehicle Centre</Trans></th>
                                                                        <th className = {this.state.sort_filter === "tier" ? "is-sorted th-center" : "th-center"} onClick={() => {this.updateSorting("tier")}}><Trans>Tier </Trans> <i className = {"sort-icon fas black-lightest" + (this.addSortClasses("tier"))}></i></th>
                                                                        <th className = {this.state.sort_filter === "bookings" ? "is-sorted th-center" : "th-center"} onClick={() => {this.updateSorting("bookings")}}><Trans>Bookings </Trans><i className = {"sort-icon fas black-lightest" + (this.addSortClasses("bookings"))}></i></th>
                                                                        <th className = {"double-line" + (this.state.sort_filter === "lastbooking" ? " is-sorted th-center" : " th-center")} onClick={() => {this.updateSorting("lastbooking")}}>
                                                                            <div className = "th-wrapper" style = {{width:'60px'}}>
                                                                                <div className = "th-text float-left"><Trans>Last<br />Booking</Trans></div><i className = {"sort-icon fas black-lightest float-left" + (this.addSortClasses("lastbooking"))}></i>
                                                                                <div className = "clearfix"></div>
                                                                            </div>
                                                                        </th>
                                                                        <th className = {"double-line" + (this.state.sort_filter === "member" ? " is-sorted th-center" : " th-center")} onClick={() => {this.updateSorting("member")}}>
                                                                            <div className = "th-wrapper" style = {{width:'60px'}}>
                                                                                <div className = "th-text float-left"><Trans>Member<br />Since</Trans></div><i className = {"sort-icon fas black-lightest float-left" + (this.addSortClasses("member"))}></i>
                                                                                <div className = "clearfix"></div>
                                                                            </div>
                                                                        </th>
                                                                        <th className = "not-sortable"><Trans>Actions</Trans></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        this.props.stakeholder.user_list.map((customer, i) =>
                                                                            <UserOverviewRow customer={customer} key={'user_row-' + customer.ID} history={this.props.history} match={this.props.match} location={this.props.location}/>
                                                                        )
                                                                    }
                                                                    <tr className="row-nohover" style={{height: '100%'}}>
                                                                        <td className="row-nohover" colSpan={10}></td>
                                                                    </tr>
                                                                    {
                                                                        ! this.state.loading_customers && this.state.next_page !== null ?
                                                                            LoadingIconRow(10)
                                                                        :
                                                                            null
                                                                    }
                                                                 </tbody>
                                                            </table>
                                                            {/*End Table Wrapper*/}
                                                        </div> 
                                                    :
                                                        <div className = "emptystate-wrapper is-shown">
                                                            {/*Empty State*/}
                                                            <h2>No Users Found</h2>
                                                            <img style={{width: "100px"}} src = "images/emptystate-icons/User_Inactive.svg"/>
                                                            <p><Trans>Try adjusting your search or filter options.</Trans></p>
                                                        </div>
                                                :
                                                   
                                                    <div className = "emptystate-wrapper is-shown">
                                                         {/*New User Empty State*/}
                                                        <h2><Trans>No Users</Trans></h2>
                                                        <img src = "images/emptystate-icons/newuser-emptystate-icon.svg"/>
                                                        <p><Trans>Lookings like you haven't added any users yet.</Trans></p>
                                                        <div className = "button-group" style= {{ width:'287px'}}>
                                                            <a className = "button primary px-32"><span className = "mr-8 float-left mt-8" style={{verticalAlign: "text-top"}}>{UserAddWhite()}</span><span><Trans>Invite User</Trans></span></a>
                                                            <a className = "button primary ml-8 px-32"><span className = "mr-8 float-left mt-8" style={{verticalAlign: "text-top"}}>{TagAddWhite()}</span><Trans>Add Internal Tag</Trans></a>
                                                        </div>
                                                        {/*<a className = "button border round">Need Help?</a>*/}
                                                    </div>
                                        }
                                </div>{/*End Table Section*/}
                            </div>
                        </div> {/*End New List View*/}
                    </div>
                </div>
                <ModalRoutes match={this.props.match} history={this.props.history}/>
            </div>
        );
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    stakeholder: store.stakeholder
})

export default connect(mapStateToProps)(UserOverview)